"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOCK_RACK_TYPES = exports.RACK_CODE_MAX_LENGTH = void 0;
exports.normalizeRackCode = normalizeRackCode;
exports.isValidRackCode = isValidRackCode;
/**
 * RACK CODE — the label of one shelf/fridge/cupboard inside a stock location (store), e.g. "A1", "FRIDGE-1", "CTRL".
 *
 * Owner, 2026-10-30 ("need proper hmis rack system"): one level only — a rack belongs to ONE store and is picked from a list;
 * it is never typed freely on a receipt. The code is stored upper-case so "a1" and "A1" cannot become two racks.
 *
 * Shared by the API (which normalises and validates every code it stores or matches) and by the screens (which show and compare
 * it) — ONE definition, so the two cannot drift.
 */
exports.RACK_CODE_MAX_LENGTH = 20;
/** Letters, digits, and the separators people actually write on a shelf label: space _ / . - (must start with a letter or digit). */
const RACK_CODE_PATTERN = /^[A-Z0-9][A-Z0-9 _/.-]*$/;
/** Trim, collapse inner runs of spaces, upper-case — the form every rack code is stored and compared in. */
function normalizeRackCode(raw) {
    return raw.trim().replace(/\s+/g, ' ').toUpperCase();
}
/** True for a code that is already normalised, 1..20 characters, and made only of the allowed characters. */
function isValidRackCode(code) {
    return code.length >= 1 && code.length <= exports.RACK_CODE_MAX_LENGTH && RACK_CODE_PATTERN.test(code);
}
/** The kinds of rack the master offers. FRIDGE / COLD_ROOM are kept so a later release can warn when a cold-chain drug is racked elsewhere. */
exports.STOCK_RACK_TYPES = ['SHELF', 'FRIDGE', 'COLD_ROOM', 'CUPBOARD', 'CONTROLLED', 'FLOOR'];
//# sourceMappingURL=stock-rack-code.js.map